import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUserRequestsData } from '../../redux/apiSlices/requestSlice';
import Spinner from '../../components/Spinner/Spinner';
import { dateFormatterShort } from '../../utils/general';
import { useState } from 'react';
import StatusModal from './StatusModal';
import { statusOptions } from './data';
import RequestInfoModal from './RequestInfoModal';





function OrganizationMain() {

  const data = useSelector(selectUserRequestsData)
  const isLoading = useSelector(state => Object.values(state.api.queries).some(query => query.status === 'pending'))

  const [showStatusModal, setShowStatusModal] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)

  const [showRequestInfoModal, setShowRequestInfoModal] = useState(false)

  const handleShowStatusModal = (rq) => {
    setSelectedRequest(rq)
    setShowStatusModal(true)
  }

  const handleShowRequestInfoModal = (rq) => {
    setSelectedRequest(rq)
    setShowRequestInfoModal(true)
  }


  



  return (
	<>
	<StatusModal
      showModal={showStatusModal}
      handleCloseModal={()=> setShowStatusModal(false)}
      status={selectedRequest?.status}
	  notice={selectedRequest?.handler_notice}
      />
	  <RequestInfoModal
      showModal={showRequestInfoModal}
      handleCloseModal={()=> setShowRequestInfoModal(false)}
      selectedRequest={selectedRequest}
      />
	<div class="col-xl-9">
		<div class="card border bg-transparent rounded-3">
			<div class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center">
				<h3 class="mb-0">قائمة الطلبات</h3>
				<div class="d-flex justify-content-end">
						{data?.verification_status === "unverified" &&
						<Link to='/create-course' class="btn btn-primary mb-0 mx-2">توثيق الحساب</Link>
  						}
						{data?.verification_status === "verified" && !data?.approved_soon &&
						<Link to='/create-course' class="btn btn-success mb-0 mx-2">طلب جديد</Link>
						}
					</div>
			</div>

			<div class="card-body">



				<div class="table-responsive border-0">
					<table class="table table-dark-gray align-middle p-4 mb-0 table-hover">
						<thead>
							<tr>
								<th scope="col" class="border-0 rounded-start">رقم العريضة</th>
								<th scope="col" class="border-0">العريضة</th>
								<th scope="col" class="border-0">التاريخ</th>
								<th scope="col" class="border-0">الحالة</th>
							</tr>
						</thead>
						{isLoading ? <div className='position-relative'> <Spinner wrapped minHeight={100} /> </div> : 
			  !data?.requests?.length ? <p className='py-3 text-center'>لم تقم بتقدبم أي طلب حتى الآن</p> :
						<tbody>
              
			  			{data?.requests?.map((rq,i)=>(
						<tr key={rq.id}>
				             <td class="text-center text-sm-start">{rq.id}</td>
							 <td>
								<h6 onClick={()=>handleShowRequestInfoModal(rq)} class="table-responsive-title mb-0">	
									<span role='button' class="hoverable-span">{rq.title}</span>
								</h6>
							 </td>
			  
			  				<td>{dateFormatterShort.format(Date.parse(rq.created_date))}</td>

							<td>
							<div class="d-flex align-items-center">
								<div class="mb-0 ms-2">
								<span class={statusOptions[rq.status].class} >{statusOptions[rq.status].displayName}</span>
								<div role="button" onClick={()=> handleShowStatusModal(rq)} class="d-flex align-items-center">
									<i class="fas fa-table  me-1"></i>
									<span class="fw-light small me-3">عرض التفاصيل</span>
								</div>
								</div>
							</div>
							</td>
						</tr>
						))}

						</tbody>
			  }
					</table>
				</div>

			</div>
		</div>
	</div>
	</>

  )
}

export default OrganizationMain